export default __webpack_public_path__ + "static/media/i125jp.d2f3d02a.webp";